<template>
    <div class="autocomplete">
      <b-input-group>
        <b-form-input type="text"
                      v-model="search"
                      :required="required"
                      @click="isOpen = true"
                      :formatter="formatter"
                      :disabled="disabled"
                      autocomplete="off"
                      :placeholder="placeholder"
                      @input="onChange">
        </b-form-input>
        <b-input-group-text>
          <Icon icon="angle-double-down" size="1x"></Icon>
        </b-input-group-text>
      </b-input-group>
        <ul v-show="isOpen && (items.length > 0 || !!extraOption)" class="autocomplete-results">
            <li v-for="(item, i) in items"
                :key="i"
                @click="setResult(item)"
                class="autocomplete-result">
                {{ item.text }}
            </li>
            <li v-if="extraOption"
                :key="'extraOption'"
                @click="extraOptionClicked"
                class="autocomplete-result">
                {{extraOption}}
            </li>
        </ul>
    </div>
</template>

<script>

  import _ from 'lodash';

  export default {
    name: 'autocomplete',
    props: {
      value: {},
      formatter: {},
      extraOption: {},
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
      required: {
        required: false,
        default: false
      },
      disabled: {
        required: false,
        default: false
      },
      placeholder: null,
      clear: null
    },
    data() {
      return {
        search: '',
        isOpen: false,
      };
    },
    watch: {
      value: function () {
        this.setValue();
      },
      items: function () {
        this.setValue();
      }
    },
    mounted() {
      this.setValue();
      document.addEventListener('click', this.handleClickOutside);
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
      setValue() {
        if (this.value && this.items.length > 0) {
          const find = this.items.find(v => this.value.hasOwnProperty('id') ? v.value.id === this.value.id : v.value.id === this.value || v.value === this.value);
          if (find) {
            this.search = find.text;
          }
        }
        if (this.clear) {
          this.search = '';
        }
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
        }
      },
      onChange: _.debounce(function () {
        this.debouncedOnChange();
      }, 500),
      debouncedOnChange() {
        this.isOpen = true;
        this.$emit('search', this.search);
        if (!this.search) {
          this.$emit('input', null);
        }
      },
      setResult(result) {
        this.search = result.text;
        this.isOpen = false;
        this.$emit('input', result.value);
      },
      extraOptionClicked() {
        this.$emit('extraOptionClicked');
      }
    }
  }
</script>

<style lang="scss" scoped>

    @import "../assets/style/base/colors";

    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid $light-grey;
        max-height: 165px;
        overflow: auto;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    }

    .autocomplete-result:hover {
        background-color: $sgp-light-blue;
        color: white;
    }
</style>